import * as React from 'react';
import TermsOfService from './TermsOfService';
import TermsOfServicePixelTracker from './TermsOfServicePixelTracker';

const ViewTermsOfServiceContainer = () => (
  <div className="ViewTermsOfServiceContainer">
    <TermsOfService title="Blend Terms of Use" showAgreeText={false} />
    <TermsOfServicePixelTracker />
  </div>
);

export default ViewTermsOfServiceContainer;
